import React, { useState, useEffect, useMemo } from 'react';
import {
  MapPin,
  Edit,
  Linkedin,
  Globe,
  Image as ImageIcon,
  PlayCircle,
  FileText,
  X,
  ChevronRight,
  Flower,
  Upload,
  Tag,
  ExternalLink, Trash2, CheckCircle2, AlertTriangle
} from 'lucide-react';
import { useRef } from 'react';
import { Loader2 } from 'lucide-react';
import SocialLinksModal from 'components/cpSignup/SocialLinksModal';
import PersonalInfoForm from 'components/crewManagement/PersonalInfoForm';
import ProfessionalInfoForm from 'components/crewManagement/ProfessionalInfoForm';
import SkillsForm from 'components/crewManagement/SkillsForm';
import EquipmentDetailsModal from 'components/cpEquipments/EquipmentDetailsModal';
import { getMyProfile, editProfile, deleteMyEquipment, createCreatorEquipment, editCreatorEquipment, uploadEquipmentPhotos, deleteFiles } from 'services/creatorService';
import { roleOptions1 } from 'data/staticData';
import { getCrewEquipment } from 'services/creatorService';
import { SOCIAL_ICONS } from 'data/staticData';
import OwnEquipmentCard from 'components/cpEquipments/EquipmentCard';
import ProfileFeaturedWorkModal from 'components/cpSignup/ProfileFeaturedWork';
import { UploadFeaturedWork, UploadPortfolio, UploadResume, UploadCertificate } from 'services/creatorService';
import AddEquipmentModal from 'components/cpEquipments/AddEditEquipmentsModal';
import EquipmentDeleteConfirmationModal from 'components/cpEquipments/DeleteEquipmentConfirmation';
import FileDeleteConfirmationModal from 'components/crewManagement/FileDeleteConfirmationModal';
import SocialLinksModalProfile from 'components/crewManagement/SocialLinksModalProfile';
import toast from 'react-hot-toast';

const CreativeProfilePage = () => {
  const [activeTab, setActiveTab] = useState('Overview');
  const [skills, setSkills] = useState(['Live Events', 'Live Events']);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isSocialLinksOpen, setIsSocialLinksOpen] = useState(false);
  const [socialLinks, setSocialLinks] = useState([]);
  const [isFeaturedWorkOpen, setIsFeaturedWorkOpen] = useState(false);
  const [editingSection, setEditingSection] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [equipments, setEquipments] = useState([]);
  const [editingLink, setEditingLink] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewData, setPreviewData] = useState({ group: null, index: 0 });
const [isBulkDelete, setIsBulkDelete] = useState(false);

  const [modalMode, setModalMode] = useState('featured');
  const [isAddingEquipment, setIsAddingEquipment] = useState(false);
  const [mode, setMode] = useState("add");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [equipmentToDeleteId, setEquipmentToDeleteId] = useState(null);
  const [isFileDeleteOpen, setIsFileDeleteOpen] = useState(false);
  const [fileToDeleteId, setFileToDeleteId] = useState(null);

  const resumeInputRef = useRef(null);
  const certificateInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [filePreview, setFilePreview] = useState(null);
  const [certPreviews, setCertPreviews] = useState({});
  const [editingProjectData, setEditingProjectData] = useState(null);

  // Equipment Modal States
  const [equipmentDetailsOpen, setEquipmentDetailsOpen] = useState(false);
  const [equipmentDetailsData, setEquipmentDetailsData] = useState(null);

  const BASE_URL = "https://beigexmemehouse.s3.amazonaws.com/beige/";

  const getFullUrl = (path) => path ? `${BASE_URL}${path}` : null;

  const recentWorks = profile?.crew_member_files?.filter(f => f.file_type === "recent_work") || [];
  const resumeFile = profile?.crew_member_files?.find(f => f.file_type === "resume");
  const certifications = useMemo(() => {
    return profile?.crew_member_files?.filter(f => f.file_type === "certifications") || [];
  }, [profile?.crew_member_files]);
  const portfolioFile = profile?.crew_member_files?.find(f => f.file_type === "portfolio");

  const baseUrl = "https://beigexmemehouse.s3.amazonaws.com/beige/";
  const filePath = profile?.crew_member_files?.find(f => f.file_type === "profile_photo")?.file_path;
  const imageUrl = filePath ? `${baseUrl}${filePath}` : "https://i.pravatar.cc/150";

  const resumeUrl = profile?.resume_file_path
    ? `${baseUrl}${profile.resume_file_path}`
    : null;

  const tabs = [
    'Overview',
    'Featured Work',
    'Certificates',
    'Resume',
    'Equipments'
  ];

  const skillOptions = [
  { value: "13", label: "Director" },
  { value: "12", label: "Livestream Audio" },
  { value: "2", label: "Video Event" },
  { value: "3", label: "Video Music" },
  { value: "4", label: "Video Lifestyle" },
  { value: "5", label: "Photo Portrait" },
  { value: "6", label: "Photo Product" },
  { value: "7", label: "Photo Event" },
  { value: "8", label: "Photo Lifestyle" },
  { value: "9", label: "Audio Engineer" },
  { value: "10", label: "Creative Director" },
  { value: "11", label: "Livestream Director" },
  { value: "1", label: "Video Commercial" },
  { value: "14", label: "Video Weddings" },
  { value: "15", label: "Photo Weddings" },
  { value: "16", label: "Portrait Photo" },
  { value: "17", label: "Cinematographer" },
];

  useEffect(() => {
    let isMounted = true;
    const previews = {};

    const resolvePreviews = async () => {
      for (const cert of certifications) {
        const originalUrl = getFullUrl(cert.file_path);
        const extension = cert.file_path.split('.').pop().toLowerCase();

        if (extension === 'pdf') {
          previews[cert.crew_files_id] = `https://docs.google.com/viewer?url=${encodeURIComponent(originalUrl)}&embedded=true`;
        } else {
          previews[cert.crew_files_id] = originalUrl;
        }
      }

      if (isMounted) {
        setCertPreviews(previews);
      }
    };

    if (certifications.length > 0) {
      resolvePreviews();
    }

    return () => {
      isMounted = false;
      Object.values(previews).forEach(url => {
        if (typeof url === 'string' && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [certifications]);

  const handleOpenEquipmentDetails = (equipmentId) => {
    // Change item.equipment_id to item.crew_equipment_id
    const equipment = equipments.find((item) => item.crew_equipment_id === equipmentId);

    if (equipment) {
      setEquipmentDetailsData(equipment);
      setEquipmentDetailsOpen(true);
    } else {
      console.error("Equipment not found for ID:", equipmentId);
    }
  };

  const openModal = (mode) => {
    setModalMode(mode);
    setIsFeaturedWorkOpen(true);
  };

  const handleViewFile = async (filePath, cachedUrl = null) => {
    if (cachedUrl) {
      const isPdf = filePath.toLowerCase().endsWith('.pdf');
      setFilePreview({ url: cachedUrl, type: isPdf ? 'pdf' : 'image' });
      return;
    }

    const originalUrl = getFullUrl(filePath);
    if (!originalUrl) return;

    const extension = filePath.split('.').pop().toLowerCase();

    if (['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(extension)) {
      setFilePreview({ url: originalUrl, type: 'image' });
      return;
    }

    if (extension === 'pdf') {
      try {
        setIsUploading(true);

        const response = await fetch(originalUrl);

        if (!response.ok) throw new Error("CORS or Network error");

        const blobData = await response.blob();
        const viewableBlob = new Blob([blobData], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(viewableBlob);

        setFilePreview({ url: blobUrl, type: 'pdf' });
      } catch (error) {
        console.error("Blob preview failed, using Google Viewer fallback:", error);

        const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(originalUrl)}&embedded=true`;
        setFilePreview({ url: googleViewerUrl, type: 'pdf' });
      } finally {
        setIsUploading(false);
      }
    } else {
      const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(originalUrl)}&embedded=true`;
      setFilePreview({ url: googleViewerUrl, type: 'image' });
    }
  };

  const groupedRecentWorks = useMemo(() => {
  const groups = {};
  recentWorks.forEach((work) => {
    // Create a unique key based on title and tags
    const key = `${work.title || 'Untitled'}-${work.tag || '[]'}`;
    if (!groups[key]) {
      groups[key] = {
        title: work.title,
        tags: JSON.parse(work.tag || '[]'),
        items: [],
      };
    }
    groups[key].items.push(work);
  });
  return Object.values(groups);
}, [recentWorks]);

  const handleFileChange = async (event, uploadType) => {
  const selectedFiles = event.target.files;
  if (!selectedFiles || selectedFiles.length === 0) return;

  const formData = new FormData();

  // Loop through all selected files and append them to 'files[]'
  for (let i = 0; i < selectedFiles.length; i++) {
    formData.append('files[]', selectedFiles[i]);
  }

  setIsUploading(true);
  try {
    let res;
    if (uploadType === 'resume') {
      res = await UploadResume(formData);
    } else if (uploadType === 'certifications') {
      res = await UploadCertificate(formData);
    }

    if (res && !res.error) {
      toast.custom((t) => (
        <div
          className={`${t.visible ? 'animate-enter' : 'animate-leave'
            } max-w-md w-full bg-[#F0FDF4] border border-[#22C55E] shadow-lg rounded-xl pointer-events-auto flex relative overflow-hidden`}
        >
          <div className="flex-1 p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 pt-0.5">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                  <CheckCircle2 className="h-6 w-6 text-[#22C55E]" />
                </div>
              </div>
              <div className="ml-3 flex-1 pr-6">
                <p className="text-base font-bold text-gray-900">
                  {uploadType.charAt(0).toUpperCase() + uploadType.slice(1)} Uploaded
                </p>
                <p className="mt-1 text-sm text-gray-500 leading-relaxed">
                  Your {uploadType} {selectedFiles.length > 1 ? 'files have' : 'has'} been uploaded successfully.
                </p>
              </div>
            </div>
          </div>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      ), { position: "bottom-right" });

      await fetchProfile();

    } else {
      toast.custom((t) => (
        <div
          className={`${t.visible ? 'animate-enter' : 'animate-leave'
            } max-w-md w-full bg-[#FEF2F2] border border-[#EF4444] shadow-lg rounded-xl pointer-events-auto flex relative overflow-hidden`}
        >
          <div className="flex-1 p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 pt-0.5">
                <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                  <AlertTriangle className="h-6 w-6 text-[#EF4444]" />
                </div>
              </div>
              <div className="ml-3 flex-1 pr-6">
                <p className="text-base font-bold text-gray-900">
                  Upload Failed
                </p>
                <p className="mt-1 text-sm text-gray-500 leading-relaxed">
                  We couldn't upload your {uploadType}. Please try again.
                </p>
              </div>
            </div>
          </div>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      ), { position: "bottom-right" });
    }
  } catch (error) {
    console.error("Upload error:", error);

    toast.custom((t) => (
      <div
        className={`${t.visible ? 'animate-enter' : 'animate-leave'
          } max-w-md w-full bg-[#FEF2F2] border border-[#EF4444] shadow-lg rounded-xl pointer-events-auto flex relative overflow-hidden`}
      >
        <div className="flex-1 p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0 pt-0.5">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                <AlertTriangle className="h-6 w-6 text-[#EF4444]" />
              </div>
            </div>
            <div className="ml-3 flex-1 pr-6">
              <p className="text-base font-bold text-gray-900">
                Upload Error
              </p>
              <p className="mt-1 text-sm text-gray-500 leading-relaxed">
                An error occurred during the upload. Please try again.
              </p>
            </div>
          </div>
        </div>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    ), { position: "bottom-right" });
  } finally {
    setIsUploading(false);
    event.target.value = ''; // Reset input so you can select the same files again
  }
};

  const handleDeleteEquipment = (equipmentId) => {
    setEquipmentToDeleteId(equipmentId);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!equipmentToDeleteId) return;

    try {
      const res = await deleteMyEquipment(equipmentToDeleteId);
      if (res && !res.error) {
        fetchEquipments();
        setIsDeleteModalOpen(false);
        setEquipmentToDeleteId(null);
      } else {
        alert(res?.error || "Failed to delete equipment");
      }
    } catch (err) {
      console.error("Delete failed", err);
      alert("An error occurred while deleting the equipment.");
    }
  };

  const handleEditProject = (group) => {
  setEditingProjectData(group);
  setModalMode("featured");
  setIsFeaturedWorkOpen(true);
};

const handleCloseFeaturedModal = () => {
  setIsFeaturedWorkOpen(false);
  setEditingProjectData(null);
};

  useEffect(() => {
    getCrewEquipment({})
      .then(response => {
        if (response?.data) {
          setEquipments(response.data);
        }
      })
      .catch(error => {
        console.error('Error fetching equipment data:', error);
      });
  }, []);

  const fetchEquipments = () => {
    getCrewEquipment({})
      .then(response => {
        if (response?.data) setEquipments(response.data);
      })
      .catch(error => console.error('Error fetching equipment:', error));
  };

  const handleAddEquipment = () => {
    setEquipmentDetailsData(null);
    setMode("add");
    setIsAddingEquipment(true);
  };

  const handleEditEquipment = (item) => {
    setEquipmentDetailsData(item);
    setMode("edit");
    setIsAddingEquipment(true);
  };

  const handleSaveEquipment = async (payload) => {
    const response = mode === 'add'
      ? await createCreatorEquipment(payload)
      : await editCreatorEquipment(payload);

    if (response?.code === 200 || response?.status === 200 || response?.success) {
      fetchEquipments();
      return response?.data?.crew_equipment_id || payload?.crew_equipment_id;
    }
    return null;
  };

  const handleUploadImages = async (crewEquipmentId, images) => {
    if (images.length > 0 && crewEquipmentId) {
      await uploadEquipmentPhotos(crewEquipmentId, images);
      fetchEquipments();
    }
  };

  const triggerFileDelete = (fileIdOrIds, bulk = false) => {
  setFileToDeleteId(fileIdOrIds); // Can be a single ID or an array of IDs
  setIsBulkDelete(bulk);
  setIsFileDeleteOpen(true);
};

// Updated confirmation handler to call API for each image
const handleConfirmFileDelete = async () => {
  if (!fileToDeleteId) return;

  try {
    const idsToDelete = Array.isArray(fileToDeleteId) ? fileToDeleteId : [fileToDeleteId];

    // Call API for each image as requested
    const results = await Promise.all(idsToDelete.map(id => deleteFiles(id)));

    const hasError = results.some(res => !res || res.error);

    if (!hasError) {
      toast.success(isBulkDelete ? "Project deleted successfully" : "Image removed");
      fetchProfile();
      setIsFileDeleteOpen(false);
      setFileToDeleteId(null);
      setPreviewData({ group: null, index: 0 }); // Close preview if open
    } else {
      toast.error("Some files failed to delete.");
    }
  } catch (err) {
    console.error("Delete Error:", err);
    toast.error("An error occurred during deletion.");
  }
};

  const fetchProfile = async () => {
    try {
      const res = await getMyProfile();
      if (!res?.error && res.data) {
        setProfile(res.data);
        const skillIds = res.data.skills?.map(s => String(s.id)) || [];
      setSkills(skillIds);

        const rawLinks = res.data.social_media_links;

        if (rawLinks) {
          try {
            let cleanedString = rawLinks;
            if (typeof rawLinks === 'string') {
              cleanedString = rawLinks.replace(/^"|"$/g, "").replace(/\\"/g, '"');
            }

            let parsedData = (typeof cleanedString === 'string') ? JSON.parse(cleanedString) : cleanedString;

            if (Array.isArray(parsedData)) {
              setSocialLinks(parsedData);
            } else if (typeof parsedData === 'object' && parsedData !== null) {
              const formattedArray = Object.entries(parsedData).map(([platform, url]) => ({
                platform,
                url
              }));
              setSocialLinks(formattedArray);
            } else {
              setSocialLinks([]);
            }
          } catch (error) {
            console.error("Error parsing social media links:", error);
            setSocialLinks([]);
          }
        } else {
          setSocialLinks([]);
        }
      }
    } catch (err) {
      console.error("Failed to fetch profile", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
    fetchEquipments();
  }, []);

  const isImage = (path) => /\.(jpg|jpeg|png|webp|gif)$/i.test(path);

  const handleEditLink = (link) => {
    setEditingLink(link);
    setIsSocialLinksOpen(true);
  };

  useEffect(() => {
    console.log("Updated socialLinks:", socialLinks);
  }, [socialLinks])

  const handleProfileChange = (updatedFields) => {
    setProfile(prev => ({
      ...prev,
      ...updatedFields
    }));
  };

  const saveProfileData = async (payload) => {
    try {
      const res = await editProfile(payload);
      if (!res?.error) {
        alert("Profile updated successfully!");
        setEditingSection(null);
        fetchProfile();
      }
    } catch (err) { console.error(err); }
  };

  const handleSaveProfile = async () => {
    try {
      let locationValue = profile.location;

      if (typeof locationValue === 'string') {
        try {
          if (locationValue.trim().startsWith('{')) {
            locationValue = JSON.parse(locationValue);
          }
        } catch (e) {
          console.error("Location parsing failed", e);
        }
      }

      const payload = {
        first_name: profile.first_name,
        last_name: profile.last_name,
        email: profile.email,
        phone_number: profile.phone_number,
        working_distance: profile.working_distance,
        primary_role: profile.primary_role,
        bio: profile.bio,
        years_of_experience: profile.years_of_experience,
        hourly_rate: profile.hourly_rate,
        location: locationValue,
      };

      const res = await editProfile(payload);

      if (!res?.error) {
        // SUCCESS TOAST
        toast.custom((t) => (
          <div
            className={`${t.visible ? 'animate-enter' : 'animate-leave'
              } max-w-md w-full bg-[#F0FDF4] border border-[#22C55E] shadow-lg rounded-xl pointer-events-auto flex relative overflow-hidden`}
          >
            <div className="flex-1 p-4">
              <div className="flex items-start">
                <div className="flex-shrink-0 pt-0.5">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                    <CheckCircle2 className="h-6 w-6 text-[#22C55E]" />
                  </div>
                </div>
                <div className="ml-3 flex-1 pr-6">
                  <p className="text-base font-bold text-gray-900">
                    Profile Updated
                  </p>
                  <p className="mt-1 text-sm text-gray-500 leading-relaxed">
                    Your profile details have been saved successfully.
                  </p>
                </div>
              </div>
            </div>
            <button
              onClick={() => toast.dismiss(t.id)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        ), { position: "bottom-right" });

        setEditingSection(null);
        if (typeof fetchProfile === 'function') await fetchProfile();

      } else {
        showErrorToast("Update Failed", "We couldn't save your profile changes. Please try again.");
      }
    } catch (err) {
      console.error("Save failed", err);
      showErrorToast("Error", "An unexpected error occurred while saving.");
    }
  };

  const handleSavePProfile = async () => {
    try {
      let locationValue = profile.location;

      if (typeof locationValue === 'string') {
        try {
          if (locationValue.trim().startsWith('{')) {
            locationValue = JSON.parse(locationValue);
          }
        } catch (e) {
          console.error("Location parsing failed", e);
        }
      }

      const payload = {
        primary_role: Array.isArray(profile.primary_role)
            ? profile.primary_role
            : [profile.primary_role],
        bio: profile.bio,
        years_of_experience: profile.years_of_experience,
        hourly_rate: profile.hourly_rate,
      };

      const res = await editProfile(payload);

      if (!res?.error) {
        // SUCCESS TOAST
        toast.custom((t) => (
          <div
            className={`${t.visible ? 'animate-enter' : 'animate-leave'
              } max-w-md w-full bg-[#F0FDF4] border border-[#22C55E] shadow-lg rounded-xl pointer-events-auto flex relative overflow-hidden`}
          >
            <div className="flex-1 p-4">
              <div className="flex items-start">
                <div className="flex-shrink-0 pt-0.5">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                    <CheckCircle2 className="h-6 we-6 text-[#22C55E]" />
                  </div>
                </div>
                <div className="ml-3 flex-1 pr-6">
                  <p className="text-base font-bold text-gray-900">
                    Professional Profile Updated
                  </p>
                  <p className="mt-1 text-sm text-gray-500 leading-relaxed">
                    Your professional details and rates have been saved.
                  </p>
                </div>
              </div>
            </div>
            <button
              onClick={() => toast.dismiss(t.id)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        ), { position: "bottom-right" });

        setEditingSection(null);
        if (typeof fetchProfile === 'function') await fetchProfile();

      } else {
        showErrorToast("Update Failed", "We couldn't save your professional details. Please try again.");
      }
    } catch (err) {
      console.error("Save failed", err);
      showErrorToast("Error", "An unexpected error occurred while updating your profile.");
    }
  };

  const handleSaveSProfile = async () => {
    try {
      const payload = {
        skills: skills
      };

      const res = await editProfile(payload);

      if (!res?.error) {
        // SUCCESS TOAST
        toast.custom((t) => (
          <div
            className={`${t.visible ? 'animate-enter' : 'animate-leave'
              } max-w-md w-full bg-[#F0FDF4] border border-[#22C55E] shadow-lg rounded-xl pointer-events-auto flex relative overflow-hidden`}
          >
            <div className="flex-1 p-4">
              <div className="flex items-start">
                <div className="flex-shrink-0 pt-0.5">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                    <CheckCircle2 className="h-6 w-6 text-[#22C55E]" />
                  </div>
                </div>
                <div className="ml-3 flex-1 pr-6">
                  <p className="text-base font-bold text-gray-900">
                    Profile Updated
                  </p>
                  <p className="mt-1 text-sm text-gray-500 leading-relaxed">
                    Your profile skills have been updated successfully.
                  </p>
                </div>
              </div>
            </div>
            <button
              onClick={() => toast.dismiss(t.id)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        ), { position: "bottom-right" });

        setEditingSection(null);
        if (typeof fetchProfile === 'function') await fetchProfile();

      } else {
        // API RETURNED ERROR TOAST
        showErrorToast("Update Failed", "We couldn't update your profile. Please try again.");
      }
    } catch (err) {
      // SYSTEM/NETWORK ERROR TOAST
      showErrorToast("Error", "An unexpected error occurred. Please try again.");
      console.error("Save failed", err);
    }
  };

  // Helper function to keep the main function clean
  const showErrorToast = (title, message) => {
    toast.custom((t) => (
      <div
        className={`${t.visible ? 'animate-enter' : 'animate-leave'
          } max-w-md w-full bg-[#FEF2F2] border border-[#EF4444] shadow-lg rounded-xl pointer-events-auto flex relative overflow-hidden`}
      >
        <div className="flex-1 p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0 pt-0.5">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                <AlertTriangle className="h-6 w-6 text-[#EF4444]" />
              </div>
            </div>
            <div className="ml-3 flex-1 pr-6">
              <p className="text-base font-bold text-gray-900">
                {title}
              </p>
              <p className="mt-1 text-sm text-gray-500 leading-relaxed">
                {message}
              </p>
            </div>
          </div>
        </div>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    ), { position: "bottom-right" });
  };

  const handleSocialLinksChange = (updatedLinks) => {
    setSocialLinks(updatedLinks);
  };

  const getRoleNames = (roleData) => {
    if (!roleData) return "Role not specified";

    let roleIds = [];

    try {
      // If it's a string that looks like a JSON array: "[\"9\", \"10\"]"
      if (typeof roleData === 'string' && roleData.startsWith('[')) {
        roleIds = JSON.parse(roleData);
      }
      // If it's already an actual array: ["9", "10"]
      else if (Array.isArray(roleData)) {
        roleIds = roleData;
      }
      // If it's a single string ID: "9"
      else {
        roleIds = [roleData];
      }
    } catch (error) {
      console.error("Error parsing roles:", error);
      roleIds = [roleData]; // Fallback to treating it as a single value
    }

    // Find the labels for all IDs
    const labels = roleIds
      .map((id) => roleOptions1.find((option) => String(option.value) === String(id))?.label)
      .filter(Boolean); // Remove any undefined results if ID isn't found

    return labels.length > 0 ? labels.join(", ") : "Role not specified";
  };

  const removeSkill = (index) => {
    const newSkills = skills.filter((_, i) => i !== index);
    setSkills(newSkills);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading profile...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FFFBF7] dark:bg-dark-grey md:p-4 lg:p-8 font-sans transition-colors duration-300">
      <style>{`
        body, button, input, textarea, select, span, p, h1, h2, h3, h4, div {
          font-family: 'font-sans', ui-sans-serif, system-ui, -apple-system, sans-serif !important;
        }
      `}</style>
      <div className="w-full md:max-w-7xl mx-auto space-y-8">
        {/* Profile Section */}
        <div className="bg-white dark:bg-black-primary md:rounded-[32px] border border-[#F0E6D9] dark:border-zinc-800 shadow-sm overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left Section – Profile */}
            <div className="p-4 lg:p-8 flex flex-col justify-between h-full">
              <div>
                {/* Profile Header */}
                <div className="flex flex-col items-start gap-4 md:gap-5 mb-4 md:mb-5">
                  <div className="flex gap-3 items-center">
                    <div className="relative shrink-0">
                      <div className="w-[72px] h-[72px] rounded-full overflow-hidden border-[3px] border-white shadow-sm ring-1 ring-gray-100">
                        <img
                          src={imageUrl}
                          alt="Profile"
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="absolute bottom-0 right-0 w-5 h-5 bg-[#22C55E] border-[3px] border-white rounded-full" />
                    </div>
                    <span className="flex bg-[#ECFDF5] text-[#059669] text-[11px] font-bold px-3 py-1 rounded-full h-fit items-center gap-1">
                      Available <ChevronRight className="w-3 h-3" />
                    </span>
                  </div>

                  <div className="md:pt-1">
                    <h1 className="text-2xl font-medium dark:text-white">
                      {profile.first_name} {profile.last_name}
                    </h1>
                    <p className="text-gray-500 text-base dark:text-white">
                      {getRoleNames(profile?.primary_role)}
                    </p>

                    <div className="flex items-center gap-1.5 text-gray-500 text-[13px] mt-3 font-medium dark:text-white">
                      <MapPin className="w-4 h-4 shrink-0" />
                      {profile.location || "Location not specified"}
                    </div>
                  </div>
                </div>

                {/* Skills */}
                {profile?.skills?.length > 0 && (
                  <div className="flex flex-wrap gap-2 mb-4 md:mb-8 dark:text-white">
                    {profile?.skills?.map((skill, i) => (
                      <span
                        key={i}
                        className="px-2 md:px-5 py-2 border border-[#E5E7EB] rounded-xl text-sm font-semibold dark:text-white whitespace-nowrap"
                      >
                        {skill.name}
                      </span>
                    ))}
                  </div>
                )}

                {/* Stats - Now more compact */}
                <div className="bg-[#FEFCF9] dark:bg-zinc-800/40 rounded-xl p-2 md:p-3 flex border border-[#F5EFE9] dark:border-zinc-800 mb-4 md:mb-6">
                  {[
                    { v: `$${profile?.hourly_rate || 0}`, l: "/Hour" },
                    {
                      v: `${profile?.years_of_experience || 0} Years`,
                      l: "Experience",
                    },
                    { v: profile?.working_distance || "—", l: "Radius" },
                  ].map((s, i) => (
                    <div
                      key={i}
                      className={`flex-1 text-center ${
                        i < 2
                          ? "border-r border-[#E8DDD3] dark:border-zinc-700"
                          : ""
                      }`}
                    >
                      {/* Smaller text values */}
                      <p className="text-base md:text-lg font-bold dark:text-white leading-tight">
                        {s.v}
                      </p>
                      {/* Smaller label text */}
                      <p className="text-xs md:text-[10px] text-gray-400 md:font-bold capitalize tracking-wide">
                        {s.l}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Footer Buttons */}
              <div className="flex flex-wrap gap-2 md:gap-4 md:mt-8 items-center">
                {/* Render all social media links */}
                {SOCIAL_ICONS.map((social) => {
                  const link = socialLinks.find(
                    (l) => l.platform === social.id,
                  );
                  if (link) {
                    return (
                      <div
                        key={social.id}
                        className="flex items-center space-x-3"
                      >
                        {/* Social Media Icon */}
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 h-8 md:h-12 border rounded-lg md:rounded-xl text-[#B2A499] flex items-center justify-center px-2 md:px-4"
                        >
                          {social.icon ? (
                            <social.icon className="inline w-5 h-5 mr-2" />
                          ) : (
                            <img
                              src={social.src}
                              alt={social.label}
                              className="inline w-5 h-5 mr-2"
                            />
                          )}
                          {social.label}
                        </a>
                      </div>
                    );
                  }
                  return null;
                })}
                <button
                  onClick={() => setIsSocialLinksOpen(true)}
                  className="p-1.5 md:p-3.5 flex items-center justify-center rounded-lg md:rounded-xl border border-gray-300 text-blue-500 hover:bg-blue-50"
                >
                  <Edit className="w-5 h-5 text-[#A59479]" />
                </button>
              </div>
            </div>

            {/* Right Section – Featured Work Upload */}
            <div className="p-4 pt-0 md:p-8 flex items-center justify-center">
              {portfolioFile ? (
                /* PORTFOLIO DISPLAY MODE */
                <div className="relative w-full max-w-[510px] min-h-[400px] rounded-[28px] overflow-hidden group border border-[#F0E6D9] dark:border-zinc-800 bg-white dark:bg-black-primary">
                  {isImage(portfolioFile.file_path) ? (
                    <img
                      src={getFullUrl(portfolioFile.file_path)}
                      alt="Portfolio"
                      className="w-full h-full object-cover min-h-[400px]"
                    />
                  ) : (
                    <video
                      src={getFullUrl(portfolioFile.file_path)}
                      className="w-full h-full object-cover min-h-[400px]"
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  )}

                  {/* HOVER OVERLAY */}
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-start justify-end p-6">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        triggerFileDelete(portfolioFile.crew_files_id);
                      }}
                      className="bg-white text-red-500 px-4 py-2 rounded-full flex items-center gap-2 text-sm font-bold shadow-lg hover:bg-red-50 transition-colors"
                    >
                      <X className="w-4 h-4" />
                      Remove
                    </button>
                  </div>

                  <div className="absolute bottom-6 left-6 bg-black/50 backdrop-blur-md text-white px-3 py-1 rounded-lg text-xs font-semibold">
                    Portfolio Highlight
                  </div>
                </div>
              ) : (
                /* UPLOAD PLACEHOLDER MODE */
                <div
                  onClick={() => openModal("portfolio")}
                  className="w-full max-w-[510px] min-h-[400px] bg-[#FEFCF9] dark:bg-zinc-900/40 border border-[#F0E6D9] dark:border-zinc-800 rounded-[28px] flex flex-col items-center justify-center text-center relative overflow-hidden cursor-pointer hover:border-[#E8DDD3] dark:hover:border-zinc-700 hover:shadow-md transition-all group"
                >
                  {/* Decorative Floating Cards Section */}
                  <div className="absolute inset-0 flex items-center justify-center -translate-y-10 pointer-events-none mb-10">
                    {/* Main decorative card (Center) - Changed bg for light mode */}
                    <div className="w-[140px] h-[220px] bg-white dark:bg-zinc-800 rounded-2xl border border-[#E8DDD3] dark:border-zinc-700 shadow-sm z-10" />

                    {/* Side card left - Changed bg for light mode */}
                    <div className="absolute w-[100px] h-[100px] bg-[#FDFCFB] dark:bg-zinc-700 rounded-2xl border border-[#E8DDD3] dark:border-zinc-700 shadow-sm -translate-x-24 translate-y-4" />

                    {/* Side card right - Changed bg for light mode */}
                    <div className="absolute w-[120px] h-[80px] bg-white dark:bg-zinc-800 rounded-2xl border border-[#E8DDD3] dark:border-zinc-700 shadow-sm translate-x-20 translate-y-8" />

                    {/* Decorative Icons */}
                    <div className="absolute translate-x-24 -translate-y-24 text-gray-300 dark:text-zinc-600">
                      <ImageIcon className="w-6 h-6" />
                    </div>
                    <div className="absolute translate-x-24 -translate-y-12 text-gray-300 dark:text-zinc-600">
                      <PlayCircle className="w-6 h-6" />
                    </div>
                  </div>

                  {/* Text Content */}
                  <div className="relative z-10 mt-60 px-6">
                    <h3 className="text-[16px] font-bold text-gray-900 dark:text-white mb-2">
                      Drag and drop media, or{" "}
                      <span className="underline underline-offset-4 decoration-gray-300 dark:decoration-zinc-700">
                        browse
                      </span>
                    </h3>
                    <p className="text-gray-500 dark:text-zinc-400 text-[13px] leading-relaxed mb-3">
                      Choose an image (png, jpg, gif) or video (mp4) for your
                      main profile highlight.
                    </p>
                    <p className="text-[#9CA3AF] dark:text-zinc-500 text-[11px]">
                      Min 1600 × 1200. Max 10MB (images), 20MB (videos).
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="mx-4 md:mx-0 border-b border-gray-200">
          <div className="flex flex-nowrap overflow-x-auto no-scrollbar gap-2 md:gap-10 md:flex-wrap md:overflow-visible">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`text-sm md:text-[15px] font-medium transition-all relative px-2 pb-3 md:p-0 md:pb-4 whitespace-nowrap ${
                  activeTab === tab
                    ? 'text-gray-900 dark:text-white after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[3px] after:bg-gray-900 dark:after:bg-white after:rounded-t-full bg-accent/20 bg-transparent'
                    : "text-gray-500 dark:text-grey-primary hover:text-gray-800 dark:hover:text-zinc-300"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-6 pb-4">
          {activeTab === "Equipments" && (
            <div className="w-full">
              {/* Thin divider line */}
              {/* <div className="border-t border-[#F1E9E0] dark:border-zinc-800 mb-6" /> */}

              {equipments.length > 0 ? (
                /* GRID VIEW: Shows when you have at least one piece of equipment */
                <div className="mx-4 md:mx-0 bg-white dark:bg-black-primary rounded-3xl p-8 border border-[#E8DDD3] dark:border-zinc-800 shadow-sm relative">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Add New Equipment Button Card */}
                    <div
                      onClick={handleAddEquipment}
                      className="flex flex-col items-center justify-center min-h-[200px] md:min-h-[420px] rounded-2xl border-2 border-dashed border-[#E8DDD3] dark:border-zinc-700 bg-[#FFFBF7] dark:bg-zinc-900/40 cursor-pointer hover:border-[#DAA06D] dark:hover:border-beige transition"
                    >
                      <div className="w-14 h-14 rounded-full bg-white dark:bg-zinc-800 shadow flex items-center justify-center mb-5">
                        <span className="text-2xl font-medium dark:text-white">
                          +
                        </span>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                        Add New Equipment
                      </h3>
                    </div>

                    {equipments.map((item) => (
                      <OwnEquipmentCard
                        key={item.crew_equipment_id}
                        item={item}
                        handleOpenEquipmentDetails={handleOpenEquipmentDetails}
                        handleEditEquipment={handleEditEquipment}
                        handleDeleteEquipment={handleDeleteEquipment}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                /* EMPTY STATE: Matches the "Perfect" Design */
                <div className="relative w-full h-[460px] rounded-[24px] overflow-hidden">
                  {/* 1. Background: 4 panels with the gap you liked */}
                  <div className="absolute inset-0 grid grid-cols-4 gap-[6px]">
                    <div className="bg-[#FBF9F7]"></div>
                    <div className="bg-[#FBF9F7]"></div>
                    <div className="bg-[#FBF9F7]"></div>
                    <div className="bg-[#FBF9F7]"></div>
                  </div>

                  {/* 2. Content Overlay */}
                  <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
                    <h3 className="text-[18px] font-bold text-[#111111] mb-1.5 tracking-tight">
                      List your equipment
                    </h3>

                    {/* SLIGHT LONG LINE (max-w-[480px]) */}
                    <p className="text-[14px] text-[#666666] leading-snug mb-6 max-w-[480px]">
                      Showcase the professional gear and tools you use to
                      deliver high-quality results for your production projects.
                    </p>

                    <button
                      onClick={handleAddEquipment}
                      className="bg-[#1A1A1A] text-white text-[14px] font-semibold px-8 py-2.5 rounded-xl hover:bg-black transition-all active:scale-95"
                    >
                      Add Equipment
                    </button>

                    <p className="text-[11.5px] text-[#999999] mt-5">
                      Cameras, lenses, lighting, or any specialized gear you
                      own.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
          {activeTab === "Certificates" && (
            <div className="w-full">
              {certifications.length > 0 ? (
                /* --- GRID VIEW (When certificates exist) --- */
                <div className="bg-white dark:bg-black-primary rounded-3xl p-8 border border-[#E8DDD3] dark:border-zinc-800 shadow-sm relative">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* Add Certificate Card */}
                    <div
                      onClick={() => certificateInputRef.current?.click()}
                      className="flex flex-col items-center justify-center min-h-[250px] border-2 border-dashed border-gray-200 dark:border-zinc-700 rounded-2xl bg-[#FEFCF9] dark:bg-zinc-900/30 cursor-pointer hover:bg-gray-50 dark:hover:bg-zinc-800/50 transition"
                    >
                      <div className="w-10 h-10 rounded-full bg-[#F5F5F5] dark:bg-zinc-800 shadow-sm flex items-center justify-center mb-4">
                        {isUploading ? (
                          <Loader2 className="animate-spin w-5 h-5 text-black dark:text-white" />
                        ) : (
                          <span className="text-xl dark:text-white">+</span>
                        )}
                      </div>
                      <p className="font-bold dark:text-white">
                        Add Certificate
                      </p>
                      <span className="text-sm text-center text-[#595959] dark:text-white/80">
                        Highlight your achievements with a professional
                        certificate.
                      </span>
                    </div>

                    {/* Dynamic List */}
                    {certifications.map((cert, idx) => {
                      const cachedUrl = certPreviews[cert.crew_files_id];
                      const previewUrl = certPreviews[cert.crew_files_id];
                      const isPdf = cert.file_path
                        .toLowerCase()
                        .endsWith(".pdf");

                      return (
                        <div
                          key={idx}
                          className="relative group bg-[#F9FAFB] dark:bg-zinc-800/40 rounded-2xl p-6 border border-gray-100 dark:border-zinc-800 flex flex-col min-h-[250px] flex-grow overflow-hidden"
                        >
                          {/* FILE PREVIEW BACKGROUND */}
                          <div className="absolute inset-0 z-0 opacity-90 group-hover:opacity-100 transition-opacity">
                            {previewUrl ? (
                              isPdf ? (
                                <iframe
                                  src={previewUrl}
                                  className="w-full h-full pointer-events-none border-none relative"
                                  style={{ overflow: "hidden" }}
                                  scrolling="no"
                                />
                              ) : (
                                <img
                                  src={previewUrl}
                                  alt="preview"
                                  className="w-full h-full object-cover pointer-events-none"
                                />
                              )
                            ) : (
                              /* Loading Placeholder */
                              <div className="w-full h-full bg-gray-100 dark:bg-zinc-800 animate-pulse" />
                            )}
                            {/* TOP FADE OVERLAY */}
                            <div
                              className="absolute inset-x-0 top-0 h-1/2 z-10"
                              style={{
                                background:
                                  "linear-gradient(180deg, rgba(20, 23, 31, 0.80) 0%, rgba(20, 23, 31, 0.00) 100%)",
                              }}
                            />
                            {/* BOTTOM FADE OVERLAY */}
                            <div
                              className="absolute inset-x-0 bottom-0 h-1/2 z-10"
                              style={{
                                background:
                                  "linear-gradient(0deg, rgba(20, 23, 31, 0.80) 12%, rgba(20, 23, 31, 0.00) 50%)",
                              }}
                            />
                          </div>

                          {/* EXISTING CONTENT (Wrapped in relative z-10 to stay above preview) */}
                          <div className="relative z-10 flex flex-col h-full flex-1 justify-between">
                            {/* Action Buttons */}
                            <div className="flex justify-end items-center gap-2">
                              <button
                                onClick={() =>
                                  handleViewFile(cert.file_path, cachedUrl)
                                }
                                className="opacity-100 transition shadow-sm text-white"
                              >
                                <ExternalLink className="w-6 h-6" />
                              </button>
                              <button
                                onClick={() =>
                                  triggerFileDelete(cert.crew_files_id)
                                }
                                className="opacity-100 transition shadow-sm text-white"
                              >
                                <Trash2 className="w-6 h-6" />
                              </button>
                            </div>
                            <div className="mt-auto pt-4">
                              <h4 className="font-bold text-white truncate">
                                Certificate_{idx + 1}
                              </h4>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                /* --- SAME EMPTY STATE UI AS FEATURED WORK --- */
                <div className="relative w-full h-[460px] rounded-[24px] overflow-hidden">
                  {/* 1. Background: 4 panels with the gap you liked */}
                  <div className="absolute inset-0 grid grid-cols-4 gap-[6px]">
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                  </div>

                  {/* 2. Content Overlay */}
                  <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
                    <h3 className="text-[18px] font-bold text-[#111111] dark:text-white mb-1.5 tracking-tight">
                      Showcase your certifications
                    </h3>

                    {/* INCREASED MAX-W TO 480px TO MAKE THE LINE LONGER */}
                    <p className="text-[14px] text-[#666666] dark:text-white leading-snug mb-6 max-w-[480px]">
                      Upload your professional credentials and achievements to
                      build trust with clients.
                    </p>

                    <button
                      disabled={isUploading}
                      onClick={() => certificateInputRef.current?.click()}
                      className="bg-[#1A1A1A] text-white text-[14px] font-semibold px-8 py-2.5 rounded-xl hover:bg-black transition-all active:scale-95 flex items-center gap-2"
                    >
                      {isUploading && (
                        <Loader2 className="animate-spin w-4 h-4" />
                      )}
                      {isUploading ? "Uploading..." : "Add Certificate"}
                    </button>

                    <p className="text-[11.5px] text-[#999999] dark:text-white mt-5">
                      PDF, JPG, DOCX or PNG files. Max 10MB per file.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === "Resume" && (
            <div className="w-full">
              {resumeFile ? (
                /* VIEW STATE: When resume exists */
                <div className="flex justify-center py-4 md:py-10 mx-4 md:mx-0">
                  <div className="relative group w-full max-w-md p-8 border border-[#E8DDD3] dark:border-zinc-800 rounded-[32px] bg-[#FBF9F7] dark:bg-black-primary text-center shadow-sm">
                    {/* Delete Button */}
                    <div className="absolute top-4 right-4 opacity:100 md:opacity-0 md:group-hover:opacity-100 transition">
                      <button
                        onClick={() =>
                          triggerFileDelete(resumeFile.crew_files_id)
                        }
                        className="p-2 bg-white dark:bg-zinc-800 rounded-full shadow-md text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>

                    {/* File Icon Box */}
                    <div className="w-16 h-16 bg-white dark:bg-zinc-900 rounded-2xl shadow-sm flex items-center justify-center mx-auto mb-6 border dark:border-zinc-800">
                      <FileText className="w-8 h-8 text-red-500" />
                    </div>

                    {/* Text Content */}
                    <h3 className="text-lg font-bold mb-1 text-[#111111] dark:text-white">
                      My Resume
                    </h3>
                    <p className="text-[#666666] dark:text-zinc-400 text-sm mb-6">
                      Uploaded on{" "}
                      {new Date(resumeFile.created_at).toLocaleDateString()}
                    </p>

                    {/* Action Buttons */}
                    <div className="flex gap-3 justify-center">
                      <button
                        onClick={() => handleViewFile(resumeFile.file_path)}
                        className="px-6 py-2.5 bg-[#1A1A1A] dark:bg-white text-white dark:text-black rounded-xl text-sm font-semibold hover:bg-black dark:hover:bg-zinc-200 transition"
                      >
                        View File
                      </button>
                      <button
                        disabled={isUploading}
                        onClick={() => resumeInputRef.current?.click()}
                        className="px-6 py-2.5 border border-[#E8DDD3] dark:border-zinc-700 bg-white dark:bg-zinc-800 rounded-xl text-sm font-semibold text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-zinc-700 flex items-center gap-2 transition"
                      >
                        {isUploading && (
                          <Loader2 className="animate-spin w-4 h-4" />
                        )}
                        Replace
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                /* EMPTY STATE: Matches the "Perfect" Design */
                <div className="relative w-full h-[250px] md:h-[460px] rounded-[24px] overflow-hidden">
                  {/* 1. Background: 4 panels with the gap you liked */}
                  <div className="absolute inset-0 grid grid-cols-1 md:grid-cols-4 gap-[6px]">
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="hidden md:block bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="hidden md:block bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="hidden md:block bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                  </div>

                  {/* 2. Content Overlay */}
                  <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
                    <h3 className="text-[18px] font-bold text-[#111111] dark:text-white mb-1.5 tracking-tight">
                      Upload your resume
                    </h3>

                    {/* SLIGHT LONG LINE (max-w-[480px]) */}
                    <p className="text-[14px] text-[#666666] dark:text-zinc-200 leading-snug mb-2 md:mb-6 max-w-[480px]">
                      Browse or drag and drop a file here
                    </p>

                    <button
                      disabled={isUploading}
                      onClick={() => resumeInputRef.current?.click()}
                      className="bg-[#1A1A1A] text-white text-[14px] font-semibold px-8 py-2.5 rounded-xl hover:bg-black transition-all active:scale-95 flex items-center gap-2"
                    >
                      {isUploading && (
                        <Loader2 className="animate-spin w-4 h-4" />
                      )}
                      {isUploading ? "Uploading..." : "Select File"}
                    </button>

                    <p className="text-[11.5px] text-[#999999] dark:text-white mt-2 md:mt-5">
                      Acceptable file types: PDF, JPG, PNG (max 5MB)
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
          {activeTab === "Featured Work" && (
            <div className="w-full">
              {groupedRecentWorks.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 p-4 md:py-0">
                  {/* 1. Add Project Placeholder Card */}
                  <div
                    onClick={() => openModal("featured")}
                    className="flex flex-col items-center justify-center h-[300px] border-2 border-dashed border-gray-200 dark:border-zinc-800 rounded-2xl bg-[#FEFCF9] dark:bg-zinc-900/50 cursor-pointer hover:bg-gray-50 dark:hover:bg-zinc-800/80 transition"
                  >
                    <div className="w-12 h-12 rounded-full bg-[#F5F5F5] dark:bg-zinc-800 shadow-sm flex items-center justify-center mb-4">
                      <span className="text-xl dark:text-white">+</span>
                    </div>
                    <p className="font-bold dark:text-white text-sm">
                      Add featured work
                    </p>
                    <span className="text-[12px] px-6 text-center text-[#595959] dark:text-white/60">
                      Upload images or videos for a new project title.
                    </span>
                  </div>

                  {/* 2. Grouped Carousels */}
                 {groupedRecentWorks.map((group, idx) => (
  <FeaturedWorkCarousel
    key={idx}
    group={group}
    isImage={isImage}
    getFullUrl={getFullUrl}
    onImageClick={(group, index) => setPreviewData({ group, index })}
    onDeleteGroup={triggerFileDelete}
    onEditGroup={() => handleEditProject(group)} // NEW PROP
  />
))}
                </div>
              ) : (
                /* EXACT SCREENSHOT MATCH: Empty State */
                <div className="relative w-full h-[460px] rounded-[24px] overflow-hidden">
                  {/* 1. Background: 4 vertical panels with thin gaps */}
                  <div className="absolute inset-0 grid grid-cols-4 gap-[8px]">
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                    <div className="bg-[#FBF9F7] dark:bg-zinc-900/40"></div>
                  </div>

                  {/* 2. Content Overlay: Centered over all panels */}
                  <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
                    <h3 className="text-[18px] font-bold text-[#111111] dark:text-white mb-1.5 tracking-tight">
                      Share your work and get discovered
                    </h3>

                    <p className="text-[14px] text-[#666666] dark:text-white leading-snug mb-6 max-w-[340px]">
                      Showcase your latest creations with the perfect image or
                      video.
                    </p>

                    <button
                      onClick={() => openModal("featured")}
                      className="bg-[#1A1A1A] text-white text-[14px] font-semibold px-7 py-2.5 rounded-xl hover:bg-black transition-all active:scale-95"
                    >
                      Upload Project
                    </button>

                    <p className="text-[11.5px] dark:text-white text-[#999999] mt-5">
                      Minimum 1600 × 1200. Max 10MB (images), 20MB (videos).
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
          {activeTab === "Overview" && (
            <>
              {/* ================= PERSONAL INFORMATION ================= */}
              <div className="bg-white dark:bg-black-primary rounded-3xl mx-4 md:mx-0 p-4 md:p-8 border border-[#E8DDD3] dark:border-zinc-800 shadow-sm relative">
                {editingSection !== "personal" ? (
                  <>
                    <div
                      className="absolute top-4 right-4 md:top-8 md:right-8 cursor-pointer text-gray-400 hover:text-gray-600"
                      onClick={() => setEditingSection("personal")}
                    >
                      <Edit className="w-5 h-5" />
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 md:mb-8">
                      Personal Information
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 md:gap-y-8 gap-x-16">
                      <Info
                        label="First Name"
                        value={profile?.first_name || "N/A"}
                      />
                      <Info
                        label="Last Name"
                        value={profile?.last_name || "N/A"}
                      />
                      <Info
                        label="Email Address"
                        value={profile?.email || "N/A"}
                      />
                      <Info
                        label="Contact Phone"
                        value={profile?.phone_number || "N/A"}
                      />
                      <Info
                        label="Location"
                        value={profile?.location || "N/A"}
                      />
                      <Info
                        label="Working Distance"
                        value={profile?.working_distance || "N/A"}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <SectionHeader
                      title="Personal Information"
                      onClose={() => setEditingSection(null)}
                      onSave={handleSaveProfile}
                    />
                    <PersonalInfoForm
                      profile={profile}
                      onChange={handleProfileChange}
                    />
                  </>
                )}
              </div>

              {/* ================= PROFESSIONAL DETAILS ================= */}
              <div className="bg-white dark:bg-black-primary rounded-3xl mx-4 md:mx-0 p-4 md:p-8 border border-[#E8DDD3] dark:border-zinc-800 shadow-sm relative">
                {editingSection !== "professional" ? (
                  <>
                    <div
                      className="absolute top-4 right-4 md:top-8 md:right-8 cursor-pointer text-gray-400 hover:text-gray-600"
                      onClick={() => setEditingSection("professional")}
                    >
                      <Edit className="w-5 h-5" />
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 md:mb-8">
                      Professional Details
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 md:gap-y-8 gap-x-16">
                      <Info
                        label="Primary Role"
                        value={getRoleNames(profile?.primary_role)}
                      />
                      <Info
                        label="Years of Experience"
                        value={profile?.years_of_experience || "N/A"}
                      />
                      <Info
                        label="Hourly Rate ($)"
                        value={profile?.hourly_rate || "N/A"}
                      />
                    </div>

                    <div className="mt-4 md:mt-8">
                      <Info label="Bio / About" value={profile?.bio || "N/A"} />
                    </div>
                  </>
                ) : (
                  <>
                    <SectionHeader
                      title="Edit Professional Details"
                      onClose={() => setEditingSection(null)}
                      onSave={handleSavePProfile}
                    />
                    <ProfessionalInfoForm
                      profile={profile}
                      onChange={handleProfileChange}
                    />
                  </>
                )}
              </div>

              {/* ================= SKILLS ================= */}
              <div className="bg-white dark:bg-black-primary rounded-3xl mx-4 md:mx-0 p-4 md:p-8 border border-[#E8DDD3] dark:border-zinc-800 shadow-sm relative">
                {editingSection !== "skills" ? (
                  <>
                    <div
                      className="absolute top-4 right-4 md:top-8 md:right-8 cursor-pointer text-gray-400 hover:text-gray-600 dark:hover:text-zinc-200"
                      onClick={() => setEditingSection("skills")}
                    >
                      <Edit className="w-5 h-5" />
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 md:mb-8">
                      Skills
                    </h2>
                    <div className="flex flex-wrap gap-4">
                      {skills.map((skillId, index) => {
                        // Look up the name based on the ID
                        const skillName =
                          skillOptions.find(
                            (opt) => String(opt.value) === String(skillId),
                          )?.label || skillId;
                        return (
                          <div
                            key={index}
                            className="flex items-center gap-3 px-4 py-2 bg-white dark:bg-zinc-800 border border-[#E5E7EB] dark:border-zinc-700 rounded-lg text-sm font-bold text-gray-900 dark:text-zinc-200 shadow-sm"
                          >
                            {skillName}
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <>
                    <SectionHeader
                      title="Edit Skills"
                      onClose={() => setEditingSection(null)}
                      onSave={handleSaveSProfile}
                    />
                    <SkillsForm
                      value={skills}
                      onChange={(updatedSkills) => setSkills(updatedSkills)}
                    />
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      <input
        type="file"
        ref={resumeInputRef}
        className="hidden"
        accept=".pdf,.doc,.docx,.jpg,.png"
        onChange={(e) => handleFileChange(e, "resume")}
      />
      <input
        type="file"
        ref={certificateInputRef}
        className="hidden"
        accept=".pdf,.jpg,.jpeg,.png"
        multiple
        onChange={(e) => handleFileChange(e, "certifications")}
      />

      {isUploading && (
        <div className="fixed inset-0 z-[200] bg-black/20 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white p-6 rounded-2xl shadow-xl flex flex-col items-center gap-4">
            <Loader2 className="w-10 h-10 animate-spin text-black" />
            <p className="font-bold">Uploading File...</p>
          </div>
        </div>
      )}

      <SocialLinksModalProfile
        open={isSocialLinksOpen}
        onClose={() => setIsSocialLinksOpen(false)}
        links={socialLinks}
        onChange={handleSocialLinksChange}
        linkToEdit={editingLink}
      />

      {filePreview && (
        <div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-black/90 p-4 md:p-10"
          onClick={() => {
            if (filePreview.url.startsWith("blob:"))
              URL.revokeObjectURL(filePreview.url);
            setFilePreview(null);
          }}
        >
          {/* Close Button */}
          <button
            className="absolute top-6 right-6 text-white bg-white/20 hover:bg-white/40 p-2 rounded-full transition-all z-[210] flex items-center gap-2"
            onClick={() => setFilePreview(null)}
          >
            <span className="text-sm font-bold ml-2">Close Preview</span>
            <X className="w-8 h-8" />
          </button>

          <div
            className="relative w-full h-[90vh] max-w-6xl bg-white rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {filePreview.type === "image" ? (
              <div className="w-full h-full flex items-center justify-center bg-gray-100">
                <img
                  src={filePreview.url}
                  alt="Preview"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            ) : (
              <iframe
                src={filePreview.url}
                className="w-full h-full border-none"
                title="File Preview"
              />
            )}
          </div>
        </div>
      )}
     {isFeaturedWorkOpen && (
  <ProfileFeaturedWorkModal
    open={isFeaturedWorkOpen}
    onClose={handleCloseFeaturedModal}
    onSuccess={fetchProfile}
    mode={editingProjectData ? "edit" : "add"} // NEW PROP
    initialData={editingProjectData} // NEW PROP
    uploadFn={modalMode === "portfolio" ? UploadPortfolio : UploadFeaturedWork}
    titleText={modalMode === "portfolio" ? "Upload Portfolio" : (editingProjectData ? "Edit Project" : "Add Featured Work")}
  />
)}
      <EquipmentDeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setEquipmentToDeleteId(null);
        }}
        onConfirm={handleConfirmDelete}
        title="Delete Equipment"
        description="Are you sure you want to remove this equipment? This action cannot be undone."
      />

      <FileDeleteConfirmationModal
        isOpen={isFileDeleteOpen}
        onClose={() => setIsFileDeleteOpen(false)}
        onConfirm={handleConfirmFileDelete}
        title="Delete File"
        description="Remove this file from your profile. This action cannot be undone."
      />

      <AddEquipmentModal
        open={isAddingEquipment}
        onOpenChange={setIsAddingEquipment}
        mode={mode}
        equipment={equipmentDetailsData}
        onSave={handleSaveEquipment}
        onUploadImages={handleUploadImages}
      />
      <EquipmentDetailsModal
        open={equipmentDetailsOpen}
        onOpenChange={setEquipmentDetailsOpen}
        equipment={equipmentDetailsData}
      />

      {previewData.group && (
        <div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-black/95 p-4 md:p-10"
          onClick={() => setPreviewData({ group: null, index: 0 })}
        >
          {/* Top Header: Title and Actions */}
          <div className="absolute top-0 inset-x-0 p-6 flex justify-between items-center bg-gradient-to-b from-black/60 to-transparent z-[210]">
            <div>
              <h3 className="text-white font-bold uppercase tracking-widest">
                {previewData.group.title}
              </h3>
              <p className="text-white/60 text-xs">
                Image {previewData.index + 1} of{" "}
                {previewData.group.items.length}
              </p>
            </div>

            <div className="flex items-center gap-4">
              {/* SINGLE DELETE BUTTON */}
              <button
                className="flex items-center gap-2 bg-red-500/20 hover:bg-red-500 text-red-500 hover:text-white px-4 py-2 rounded-full transition-all border border-red-500/50"
                onClick={(e) => {
                  e.stopPropagation();
                  triggerFileDelete(
                    previewData.group.items[previewData.index].crew_files_id,
                    false,
                  );
                }}
              >
                <Trash2 className="w-5 h-5" />
                <span className="text-sm font-bold">Delete This Image</span>
              </button>

              <button
                className="text-white bg-white/10 hover:bg-white/20 p-2 rounded-full transition"
                onClick={() => setPreviewData({ group: null, index: 0 })}
              >
                <X className="w-8 h-8" />
              </button>
            </div>
          </div>

          {/* Navigation Arrows */}
          {previewData.group.items.length > 1 && (
            <>
              <button
                className="absolute left-4 md:left-10 z-[210] p-4 bg-white/10 hover:bg-white/20 rounded-full text-white transition"
                onClick={(e) => {
                  e.stopPropagation();
                  setPreviewData((prev) => ({
                    ...prev,
                    index:
                      (prev.index - 1 + prev.group.items.length) %
                      prev.group.items.length,
                  }));
                }}
              >
                <ChevronRight className="w-8 h-8 rotate-180" />
              </button>
              <button
                className="absolute right-4 md:right-10 z-[210] p-4 bg-white/10 hover:bg-white/20 rounded-full text-white transition"
                onClick={(e) => {
                  e.stopPropagation();
                  setPreviewData((prev) => ({
                    ...prev,
                    index: (prev.index + 1) % prev.group.items.length,
                  }));
                }}
              >
                <ChevronRight className="w-8 h-8" />
              </button>
            </>
          )}

          {/* Main Image Container */}
          <div
            className="relative w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={getFullUrl(
                previewData.group.items[previewData.index].file_path,
              )}
              alt="Preview"
              className="max-w-full max-h-[85vh] object-contain shadow-2xl rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
};

// UPDATE THE Info COMPONENT:
const Info = ({ label, value }) => (
  <div>
    <label className="block text-[15px] font-bold text-gray-900 dark:text-zinc-400 mb-2">
      {label}
    </label>
    <p className="text-gray-500 dark:text-zinc-200 text-[15px]">{value}</p>
  </div>
);

// UPDATE THE SectionHeader COMPONENT:
const SectionHeader = ({ title, onClose, onSave }) => (
  <div className="flex items-center justify-between mb-6">
    <h2 className="text-2xl font-extrabold text-gray-900 dark:text-white">
      {title}
    </h2>
    <div className="flex items-center gap-3">
      <button onClick={onClose} className="h-9 px-5 rounded-full bg-[#F3EFEA] dark:bg-zinc-800 dark:text-white ...">
        Close
      </button>
      <button
        onClick={onSave}
        className="h-9 px-5 rounded-full bg-black text-white dark:bg-white dark:text-black font-medium"
      >
        Save
      </button>
    </div>
  </div>
);

const FeaturedWorkCarousel = ({ group, onImageClick, onDeleteGroup, onEditGroup, getFullUrl }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentWork = group.items[currentIndex];

  return (
    <div className="flex flex-col gap-3">
      <div className="relative group rounded-2xl overflow-hidden h-[300px] border border-gray-100 shadow-sm bg-black">
        <img
          src={getFullUrl(currentWork.file_path)}
          alt={group.title}
          className="w-full h-full object-cover cursor-zoom-in hover:opacity-95 transition-opacity"
          onClick={() => onImageClick(group, currentIndex)}
        />

        {/* Indicators */}
        {group.items.length > 1 && (
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 pointer-events-none">
            {group.items.map((_, i) => (
              <div
                key={i}
                className={`h-1.5 rounded-full transition-all ${i === currentIndex ? "w-4 bg-white" : "w-1.5 bg-white/50"}`}
              />
            ))}
          </div>
        )}

        {/* Actions Overlay */}
        <div className="absolute top-2 right-2 flex flex-col gap-2 md:opacity-0 md:group-hover:opacity-100 transition">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDeleteGroup(
                group.items.map((item) => item.crew_files_id),
                true,
              );
            }}
            className="p-2 bg-white rounded-full shadow-md text-red-500 hover:bg-red-50 flex items-center gap-1"
          >
            <Trash2 className="w-4 h-4" />
            <span className="text-[10px] font-bold pr-1">Delete Project</span>
          </button>
        </div>

        <div className="absolute top-12 right-2 flex flex-col gap-2 md:opacity-0 md:group-hover:opacity-100 transition">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEditGroup();
            }}
            className="p-2 bg-white rounded-full shadow-md text-blue-600 hover:bg-blue-50 flex items-center gap-1"
          >
            <Edit className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="px-1">
        <h4 className="text-sm font-bold text-gray-900 uppercase truncate">
          {group.title || "Untitled"}
        </h4>
        <div className="flex flex-wrap gap-2 mt-1">
          {group.tags.map((tag, i) => (
            <span key={i} className="text-[10px] font-bold text-[#A59479]">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreativeProfilePage;
